var _rect, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#F0F0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.6667L13.8275 13.9935C16.6041 13.3324 19.3189 12.4347 21.9424 11.3104L25 10L28.0576 11.3104C30.6811 12.4347 33.396 13.3324 36.1725 13.9935L39 14.6667V19.1293C39 28.2071 33.5578 36.4003 25.1901 39.92V39.92C25.0685 39.9712 24.9315 39.9712 24.8099 39.92V39.92C16.4422 36.4003 11 28.2071 11 19.1292V14.6667Z",
    stroke: "#36384C",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 19,
    r: 2,
    stroke: "#36384C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29C30 27.6739 29.4732 26.4021 28.5355 25.4645C27.5979 24.5268 26.3261 24 25 24C23.6739 24 22.4021 24.5268 21.4645 25.4645C20.5268 26.4021 20 27.6739 20 29L25 29H30Z",
    stroke: "#36384C",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/integrity.212cc35f33ba60d16dfa448f109f9346.svg";
export { ForwardRef as ReactComponent };